var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginPageIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 281,
    viewBox: "0 0 367 281",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M327.884 148.196C321.635 159.234 303.833 169.524 294.227 177.393C277.796 190.889 296.401 216.483 288.011 236.254C264.139 292.722 203.309 285.11 147.871 259.699C72.2356 225.029 23.3825 142.269 68.0531 89.7503C112.788 37.1294 234.755 -2.44804 322.296 75.5176C338.26 95.3627 340.215 126.276 327.884 148.196Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M299.04 86.7787C299.04 86.7787 293.427 98.3715 302.693 105.128C311.958 111.885 315.172 127.426 293.305 134.934",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "6 6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M312.676 56.9831C311.928 61.1699 311.97 67.8532 311.97 67.8532C311.971 68.8828 312.807 69.7134 313.882 69.6049C313.882 69.6049 320.175 69.1002 324.183 67.9995C327.328 67.1409 330.11 66.295 332.695 65.3856C342.328 62.027 348.086 58.3399 352.431 53.5182C359.415 45.8249 358.467 33.5466 350.961 26.6901C343.483 19.7902 331.275 20.0105 324.318 27.6605C320.234 32.1628 317.217 37.8824 314.846 46.7947C314.066 49.812 313.361 53.1793 312.676 56.9831ZM345.022 33.2887C349.115 37.0222 349.321 43.4459 345.54 47.6553C341.76 51.8648 335.394 52.2027 331.301 48.4691C327.209 44.7355 327.003 38.3119 330.783 34.1026C334.564 29.8931 340.93 29.5551 345.022 33.2887Z",
    fill: "white",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.851 71.747C293.65 75.6694 297.573 81.2158 297.573 81.2158C298.173 82.0942 299.396 82.2832 300.251 81.5896C300.251 81.5896 305.379 77.4281 308.129 74.1508C310.301 71.5856 312.218 69.1886 313.882 66.96C320.167 58.4495 322.941 51.9663 323.868 45.3987C325.352 34.8905 317.46 25.1793 307.069 23.8416C296.679 22.5038 286.377 29.8685 284.894 40.3768C283.99 46.5461 284.726 53.1078 287.838 61.944C288.899 64.9202 290.237 68.1488 291.851 71.747ZM305.795 32.872C311.452 33.5913 315.351 38.8337 314.54 44.5804C313.729 50.3271 308.485 54.3737 302.829 53.6544C297.172 52.9353 293.272 47.6928 294.083 41.9462C294.894 36.1995 300.138 32.1529 305.795 32.872Z",
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.181 180.616H78.1265V56.3357C78.1265 53.5773 80.3629 51.3408 83.1214 51.3408H264.186C266.944 51.3408 269.181 53.5773 269.181 56.3357V180.616Z",
    fill: "white",
    stroke: "#323233",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.725 65.5364H72.9845C70.7754 65.5364 68.9845 67.3272 68.9845 69.5364V190.986C68.9845 193.195 70.7754 194.986 72.9845 194.986H122.725C124.934 194.986 126.725 193.195 126.725 190.986V69.5364C126.725 67.3272 124.934 65.5364 122.725 65.5364Z",
    fill: "#FFC244"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M269.181 180.616H78.1265V56.3357C78.1265 53.5773 80.3629 51.3408 83.1214 51.3408H264.186C266.944 51.3408 269.181 53.5773 269.181 56.3357V180.616Z",
    stroke: "#323233",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257.942 66.0296C260.356 66.0296 262.313 64.0729 262.313 61.6591C262.313 59.2453 260.356 57.2886 257.942 57.2886C255.529 57.2886 253.572 59.2453 253.572 61.6591C253.572 64.0729 255.529 66.0296 257.942 66.0296Z",
    fill: "#323233"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.704 66.0296C249.118 66.0296 251.074 64.0729 251.074 61.6591C251.074 59.2453 249.118 57.2886 246.704 57.2886C244.29 57.2886 242.333 59.2453 242.333 61.6591C242.333 64.0729 244.29 66.0296 246.704 66.0296Z",
    fill: "#323233"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M93.746 108.019C96.1598 108.019 98.1165 106.062 98.1165 103.648C98.1165 101.235 96.1598 99.2778 93.746 99.2778C91.3322 99.2778 89.3755 101.235 89.3755 103.648C89.3755 106.062 91.3322 108.019 93.746 108.019Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M93.746 121.755C96.1598 121.755 98.1165 119.798 98.1165 117.384C98.1165 114.971 96.1598 113.014 93.746 113.014C91.3322 113.014 89.3755 114.971 89.3755 117.384C89.3755 119.798 91.3322 121.755 93.746 121.755Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M93.746 135.491C96.1598 135.491 98.1165 133.534 98.1165 131.121C98.1165 128.707 96.1598 126.75 93.746 126.75C91.3322 126.75 89.3755 128.707 89.3755 131.121C89.3755 133.534 91.3322 135.491 93.746 135.491Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5508 56.87L58.1443 59.9488M78.2975 37.8135L75.9941 29.2161L78.2975 37.8135ZM68.5669 44.9025L56.8777 37.8715L68.5669 44.9025Z",
    stroke: "#222221",
    strokeWidth: 1.666,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M106.706 212.116C81.2955 216.249 59.0704 210.693 55.7499 199.648C55.8175 200.597 55.9527 201.613 56.1556 202.563C60.4257 228.921 85.2922 246.878 111.718 242.54C138.078 238.271 156.035 213.403 151.697 186.977C151.55 186.023 151.369 185.073 151.156 184.131C151.494 195.65 132.183 207.982 106.706 212.116Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.021 182.844C150.811 181.684 150.422 180.564 149.869 179.524C150.343 181.014 150.817 182.574 151.156 184.199C151.089 183.725 151.089 183.251 151.021 182.844ZM55.4779 198.361C55.5455 198.768 55.6822 199.243 55.8174 199.648C55.6822 198.023 55.547 196.397 55.547 194.837C55.2869 195.996 55.2634 197.195 55.4779 198.362V198.361Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M106.706 212.116C132.115 207.982 151.427 195.651 151.089 184.131C150.749 182.573 150.276 181.014 149.801 179.456C144.448 169.766 123.51 165.159 99.7254 169.021C75.9422 172.882 57.5124 183.929 55.4795 194.769C55.4795 196.396 55.5471 197.955 55.7499 199.58C59.0705 210.693 81.2956 216.249 106.706 212.116Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M106.706 212.116C81.2955 216.249 59.0704 210.693 55.7499 199.648C55.8175 200.597 55.9527 201.613 56.1556 202.563C60.4257 228.921 85.2922 246.878 111.718 242.54C138.078 238.271 156.035 213.403 151.697 186.977C151.55 186.023 151.369 185.073 151.156 184.131C151.494 195.65 132.183 207.982 106.706 212.116Z",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M121.748 165.092C113.278 160.281 99.9972 167.666 92.0685 181.626C87.2589 190.095 90.1723 200.801 98.6419 205.612C107.112 210.423 117.818 207.509 122.63 199.04C130.557 185.081 130.217 169.903 121.748 165.092Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.976 200.055C109.367 200.055 111.659 199.106 113.349 197.416C115.039 195.725 115.988 193.433 115.988 191.043C115.988 188.653 115.039 186.361 113.349 184.671C111.659 182.98 109.367 182.031 106.976 182.031C104.586 182.031 102.294 182.98 100.604 184.671C98.9138 186.361 97.9644 188.653 97.9644 191.043C97.9644 193.433 98.9138 195.725 100.604 197.416C102.294 199.106 104.586 200.055 106.976 200.055Z",
    fill: "#FFC244",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M144.855 168.209C136.385 163.397 123.103 170.783 115.176 184.742C112.967 188.617 112.312 193.186 113.343 197.526C114.375 201.866 117.015 205.652 120.732 208.119C121.07 208.322 121.409 208.525 121.68 208.729C130.151 213.54 140.856 210.625 145.667 202.156C146.48 200.733 147.158 199.377 147.768 197.955C153.527 185.284 152.444 172.544 144.853 168.208L144.855 168.209Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M130.084 203.172C131.277 203.187 132.461 202.965 133.568 202.519C134.675 202.073 135.682 201.412 136.531 200.574C137.38 199.735 138.055 198.737 138.515 197.636C138.975 196.535 139.212 195.354 139.212 194.16C139.212 192.967 138.975 191.786 138.515 190.685C138.055 189.584 137.38 188.585 136.531 187.747C135.682 186.908 134.675 186.247 133.568 185.801C132.461 185.355 131.277 185.134 130.084 185.149C127.714 185.18 125.452 186.142 123.787 187.829C122.122 189.516 121.188 191.79 121.188 194.16C121.188 196.53 122.122 198.805 123.787 200.491C125.452 202.178 127.714 203.141 130.084 203.172Z",
    fill: "#FFC244",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7512 199.648C59.0703 210.694 81.2954 216.25 106.706 212.117C132.115 207.984 151.427 195.65 151.088 184.131",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.618 184.199C80.008 180.338 75.2646 181.149 74.5869 177.288C73.9784 173.426 78.7203 172.68 78.1103 168.818C77.5018 164.957 72.7584 165.768 72.0807 161.907C71.4707 158.045 76.2126 157.298 75.6041 153.437M75.6041 212.184C75.6041 212.184 71.8779 206.425 77.5694 202.698C83.2609 198.972 90.1048 194.092 90.1048 194.092L83.2609 198.903L75.6041 212.184ZM58.9353 204.662C58.9353 204.662 56.698 199.716 63.3391 195.99C69.9802 192.263 79.9404 186.503 79.9404 186.503C79.9404 186.503 86.311 182.641 90.1048 187.316L58.9353 204.662ZM64.152 194.974C63.542 191.111 68.2854 190.366 67.6754 186.503C67.0654 182.641 62.3234 183.453 61.6458 179.591C61.0358 175.73 65.7777 174.985 65.1692 171.122C64.5592 167.26 59.8157 168.071 59.1381 164.21C58.5281 160.349 63.27 159.603 62.6615 155.74L64.152 194.974Z",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9213 154.792L9.87683 169.222C7.30153 169.764 4.79384 168.071 4.25293 165.428C3.71053 162.853 5.40386 160.347 8.04677 159.804C8.11438 159.804 8.24961 159.737 8.31722 159.737L82.1085 149.775C83.5314 149.572 84.819 150.588 84.9542 151.943C85.1586 153.298 84.2781 154.588 82.9213 154.789V154.792ZM80.2784 145.305L5.81104 145.643C3.16812 145.643 1 143.543 1 140.901C1 138.257 3.10051 136.089 5.74342 136.089H6.01387L80.3475 140.224C81.0301 140.26 81.6703 140.565 82.1276 141.073C82.5849 141.581 82.8217 142.25 82.7861 142.933C82.7185 144.22 81.5661 145.305 80.2784 145.305Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M106.706 212.117C81.2955 216.25 59.0704 210.694 55.7499 199.648C55.8175 200.597 55.9527 201.613 56.1556 202.563C60.4257 228.921 85.2937 246.878 111.72 242.541C138.078 238.271 156.035 213.403 151.699 186.979C151.563 186.029 151.359 185.081 151.156 184.131C151.494 195.651 132.184 207.984 106.706 212.117Z",
    fill: "white",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M148.785 210.626C149.191 209.272 149.666 207.917 150.004 206.561C149.529 206.561 149.056 206.697 148.581 207.035C135.3 216.183 122.019 222.688 108.806 224.856C95.4566 227.024 80.7545 224.991 65.169 220.52C64.777 220.39 64.3578 220.365 63.9533 220.448C63.5489 220.531 63.1733 220.719 62.8641 220.993V221.062C63.4742 222.417 63.8813 222.823 64.897 223.908C65.6423 224.721 66.3875 225.533 67.0652 226.414C82.1083 230.412 96.4062 232.107 109.552 229.937C122.222 227.904 134.893 222.078 147.565 213.811C147.971 212.658 148.446 211.643 148.785 210.626Z",
    fill: "#FFC244"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.706 212.117C81.2955 216.25 59.0704 210.694 55.7499 199.648C55.8175 200.597 55.9527 201.613 56.1556 202.563C60.4257 228.921 85.2937 246.878 111.72 242.541C138.078 238.271 156.035 213.403 151.699 186.979C151.563 186.029 151.359 185.081 151.156 184.131C151.494 195.651 132.184 207.984 106.706 212.117V212.117Z",
    stroke: "#222221",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M157.082 203L157.082 203C157.024 202.732 156.77 202.505 156.42 202.505H152.441C152.061 202.505 151.783 202.772 151.744 203.083C151.63 203.986 151.474 205.256 151.302 206.739C151.256 207.138 150.976 207.471 150.591 207.584C149.278 207.969 148.037 208.516 146.89 209.201C146.535 209.413 146.085 209.384 145.76 209.128C144.532 208.164 143.475 207.344 142.727 206.767L142.726 206.767C142.447 206.552 142.04 206.574 141.782 206.826C141.782 206.826 141.782 206.826 141.782 206.826L138.987 209.56L138.987 209.56C138.755 209.787 138.732 210.107 138.892 210.343C139.428 211.131 140.241 212.301 141.278 213.711C141.514 214.031 141.537 214.461 141.337 214.805C140.679 215.938 140.163 217.159 139.811 218.446C139.703 218.843 139.362 219.133 138.952 219.177C137.281 219.354 135.85 219.516 134.855 219.632L134.855 219.632C134.491 219.674 134.244 219.968 134.244 220.293V224.16C134.244 224.464 134.454 224.727 134.768 224.789L134.768 224.789C135.727 224.978 137.168 225.246 138.946 225.53C139.339 225.592 139.657 225.882 139.757 226.267C140.023 227.295 140.392 228.282 140.855 229.217C141.038 229.586 140.976 230.031 140.697 230.335C139.588 231.55 138.644 232.597 137.989 233.329L137.988 233.33C137.768 233.576 137.767 233.94 137.999 234.193L157.082 203ZM157.082 203C157.259 203.82 157.502 205.009 157.761 206.473C157.832 206.875 158.14 207.193 158.539 207.277M157.082 203L158.539 207.277M158.539 207.277C160.369 207.663 162.081 208.356 163.617 209.298C163.956 209.506 164.386 209.493 164.712 209.266M158.539 207.277L164.712 209.266M164.712 209.266C165.801 208.507 166.738 207.862 167.424 207.392L167.425 207.392M164.712 209.266L167.425 207.392M167.425 207.392C167.716 207.192 168.117 207.238 168.358 207.5L168.359 207.5M167.425 207.392L168.359 207.5M168.359 207.5L171.022 210.393C171.237 210.627 171.245 210.943 171.077 211.168C170.612 211.792 169.948 212.666 169.112 213.712C168.855 214.033 168.822 214.48 169.028 214.836M168.359 207.5L169.028 214.836M169.028 214.836C169.692 215.986 170.211 217.226 170.559 218.532C170.665 218.93 171.005 219.222 171.414 219.268L169.028 214.836ZM170.623 226.141C170.718 225.756 171.032 225.465 171.422 225.397C172.734 225.17 173.807 224.959 174.569 224.802C174.878 224.738 175.083 224.478 175.083 224.178V220.285C175.083 219.96 174.839 219.669 174.478 219.625C174.478 219.625 174.478 219.625 174.478 219.625L174.598 218.632L170.623 226.141ZM170.623 226.141C170.227 227.731 169.581 229.226 168.726 230.583C168.498 230.945 168.526 231.413 168.796 231.746M170.623 226.141L168.796 231.746M168.796 231.746C169.582 232.714 170.251 233.548 170.744 234.166L170.744 234.166M168.796 231.746L170.744 234.166M170.744 234.166C170.947 234.421 170.93 234.781 170.682 235.023L170.682 235.024M170.744 234.166L170.682 235.024M170.682 235.024L167.868 237.776C167.633 238.006 167.279 238.04 167.018 237.874C166.325 237.432 165.338 236.789 164.153 235.974C163.838 235.758 163.429 235.74 163.096 235.927M170.682 235.024L163.096 235.927M163.096 235.927C161.686 236.72 160.14 237.309 158.5 237.649C158.098 237.733 157.787 238.054 157.718 238.459M163.096 235.927L157.718 238.459M157.718 238.459C157.469 239.907 157.238 241.089 157.069 241.91M157.718 238.459L157.069 241.91M157.069 241.91C157.013 242.183 156.756 242.414 156.402 242.414H152.449C152.069 242.414 151.788 242.144 151.75 241.83L157.069 241.91ZM140.644 237.067L137.999 234.193L151.75 241.83C151.641 240.93 151.492 239.666 151.326 238.19C151.281 237.789 151 237.454 150.612 237.341C148.952 236.857 147.406 236.114 146.022 235.16C145.694 234.934 145.262 234.925 144.924 235.137C143.493 236.034 142.306 236.737 141.499 237.204C141.225 237.363 140.869 237.311 140.645 237.067C140.644 237.067 140.644 237.067 140.644 237.067ZM155.275 228.27C158.537 228.27 161.218 225.678 161.218 222.435C161.218 219.191 158.536 216.599 155.275 216.599C152.014 216.599 149.332 219.191 149.332 222.435C149.332 225.678 152.014 228.27 155.275 228.27Z",
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M181.881 221.314L181.88 221.314C181.863 221.234 181.776 221.131 181.611 221.131H178.583C178.403 221.131 178.303 221.253 178.29 221.355C178.203 222.036 178.085 222.995 177.954 224.115C177.908 224.514 177.627 224.847 177.241 224.959C176.261 225.245 175.335 225.65 174.48 226.157C174.126 226.367 173.679 226.339 173.354 226.085C172.421 225.357 171.617 224.738 171.048 224.303L171.048 224.303C170.929 224.212 170.749 224.22 170.637 224.329C170.637 224.329 170.637 224.329 170.637 224.329L168.511 226.394L168.511 226.394C168.462 226.442 168.441 226.494 168.436 226.538C168.431 226.581 168.44 226.625 168.47 226.669L181.881 221.314ZM181.881 221.314C182.015 221.931 182.199 222.826 182.395 223.928C182.467 224.33 182.775 224.648 183.175 224.732M181.881 221.314L183.175 224.732M183.175 224.732C184.541 225.017 185.819 225.531 186.964 226.229C187.302 226.435 187.729 226.422 188.054 226.197M183.175 224.732L188.054 226.197M188.054 226.197C188.881 225.624 189.594 225.137 190.116 224.782L190.116 224.782M188.054 226.197L190.116 224.782M190.116 224.782C190.241 224.697 190.417 224.717 190.521 224.829L190.521 224.829M190.116 224.782L190.521 224.829M190.521 224.829L192.547 227.014C192.547 227.015 192.547 227.015 192.547 227.015C192.592 227.063 192.61 227.114 192.612 227.157C192.615 227.199 192.604 227.242 192.573 227.284C192.22 227.753 191.717 228.411 191.083 229.199C190.823 229.521 190.79 229.971 190.998 230.329M190.521 224.829L190.998 230.329M190.998 230.329C191.493 231.179 191.879 232.095 192.138 233.061C192.245 233.458 192.584 233.75 192.993 233.795M190.998 230.329L192.993 233.795M192.993 233.795C193.927 233.899 194.728 233.993 195.323 234.065L192.993 233.795ZM192.185 238.684C192.282 238.3 192.596 238.009 192.986 237.942C193.981 237.771 194.795 237.612 195.373 237.494C195.5 237.467 195.572 237.367 195.572 237.262V234.321C195.572 234.207 195.484 234.084 195.323 234.065L192.185 238.684ZM192.185 238.684C191.891 239.859 191.41 240.964 190.773 241.968C190.543 242.332 190.571 242.803 190.844 243.136M192.185 238.684L190.844 243.136M190.844 243.136C191.441 243.867 191.949 244.497 192.324 244.963L192.324 244.963M190.844 243.136L192.324 244.963M192.324 244.963C192.397 245.055 192.397 245.182 192.298 245.279L192.297 245.279M192.324 244.963L192.297 245.279M192.297 245.279L190.156 247.359M192.297 245.279L190.156 247.359M186.576 245.924C186.907 245.739 187.314 245.757 187.627 245.971C188.526 246.585 189.275 247.069 189.8 247.402L186.576 245.924ZM186.576 245.924C185.523 246.512 184.37 246.948 183.146 247.2C182.743 247.283 182.433 247.604 182.363 248.01M186.576 245.924L182.363 248.01M182.363 248.01C182.174 249.1 181.998 249.99 181.871 250.608C181.853 250.691 181.765 250.795 181.597 250.795H178.589C178.41 250.795 178.308 250.673 178.295 250.568C178.212 249.889 178.098 248.935 177.972 247.82C177.927 247.419 177.645 247.084 177.257 246.972M182.363 248.01L177.257 246.972M177.257 246.972C176.018 246.613 174.864 246.062 173.832 245.356C173.505 245.132 173.076 245.123 172.739 245.333M177.257 246.972L172.739 245.333M172.739 245.333C171.653 246.009 170.752 246.539 170.14 246.891C170.029 246.955 169.877 246.935 169.781 246.832C169.781 246.832 169.781 246.832 169.781 246.832L167.769 244.661L172.739 245.333ZM167.763 244.341L167.762 244.342C167.681 244.432 167.677 244.562 167.768 244.661L167.763 244.341ZM167.763 244.341C168.261 243.789 168.978 242.998 169.822 242.081C170.103 241.776 170.166 241.329 169.981 240.958M167.763 244.341L169.981 240.958M169.981 240.958C169.636 240.267 169.361 239.537 169.163 238.777C169.063 238.392 168.744 238.103 168.352 238.041M169.981 240.958L168.352 238.041M168.352 238.041C167.002 237.828 165.908 237.626 165.181 237.483L165.181 237.483M168.352 238.041L165.181 237.483M165.181 237.483C165.05 237.458 164.977 237.356 164.977 237.249V234.327C164.977 234.213 165.065 234.089 165.229 234.07L165.229 234.07M165.181 237.483L165.229 234.07M165.229 234.07C165.986 233.982 167.074 233.86 168.345 233.726C168.754 233.683 169.095 233.394 169.204 232.997M165.229 234.07L169.204 232.997M169.204 232.997C169.465 232.046 169.85 231.144 170.34 230.306C170.542 229.96 170.519 229.527 170.28 229.205M169.204 232.997L170.28 229.205M170.28 229.205C169.493 228.144 168.876 227.262 168.47 226.669L170.28 229.205ZM190.156 247.359C190.055 247.457 189.904 247.468 189.8 247.402L190.156 247.359ZM180.739 240.598C183.341 240.598 185.5 238.542 185.5 235.945C185.5 233.347 183.341 231.291 180.739 231.291C178.138 231.291 175.978 233.347 175.978 235.945C175.978 238.542 178.138 240.598 180.739 240.598Z",
    fill: "#16BA9B",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.03 198.545V209.571C231.03 214.873 241.221 219.174 253.792 219.174C266.364 219.174 276.554 214.874 276.554 209.571V198.545H231.03Z",
    fill: "#FFC244"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.03 198.545V209.571C231.03 214.873 241.221 219.174 253.792 219.174C266.364 219.174 276.554 214.874 276.554 209.571V198.545H231.03Z",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M276.554 197.122C276.554 202.425 266.364 206.725 253.792 206.725C241.221 206.725 231.03 202.425 231.03 197.122C231.03 191.819 241.221 187.519 253.792 187.519C266.364 187.519 276.554 191.819 276.554 197.122Z",
    fill: "#FFC244"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M253.792 206.725V219.2M276.554 197.122C276.554 202.425 266.364 206.725 253.792 206.725C241.221 206.725 231.03 202.425 231.03 197.122C231.03 191.819 241.221 187.519 253.792 187.519C266.364 187.519 276.554 191.819 276.554 197.122ZM235.598 202.893V215.367V202.893ZM243.479 205.857V216.909V205.857ZM271.631 204.316V215.367V204.316ZM263.751 205.857V216.909V205.857Z",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.549 183.66V194.686C234.549 199.989 244.739 204.289 257.311 204.289C269.883 204.289 280.073 199.989 280.073 194.686V183.66H234.549Z",
    fill: "#FFC244"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M234.549 183.66V194.686C234.549 199.989 244.739 204.289 257.311 204.289C269.883 204.289 280.073 199.989 280.073 194.686V183.66H234.549V183.66Z",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M280.073 182.237C280.073 187.542 269.883 191.84 257.311 191.84C244.739 191.84 234.549 187.542 234.549 182.237C234.549 176.935 244.739 172.635 257.311 172.635C269.883 172.635 280.073 176.934 280.073 182.237Z",
    fill: "#FFC244"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M257.311 191.84V204.316M280.073 182.237C280.073 187.542 269.883 191.84 257.311 191.84C244.739 191.84 234.549 187.542 234.549 182.237C234.549 176.935 244.739 172.635 257.311 172.635C269.883 172.635 280.073 176.934 280.073 182.237V182.237ZM239.116 188.008V200.482V188.008ZM246.998 190.972V202.025V190.972ZM275.15 189.431V200.484V189.431ZM267.269 190.972V202.025V190.972Z",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M285.976 202.593V208.024H291.408L307.428 192.004L301.996 186.572L285.976 202.593ZM311.629 187.804C312.194 187.239 312.194 186.326 311.629 185.761L308.239 182.372C308.105 182.238 307.946 182.131 307.771 182.058C307.596 181.986 307.408 181.948 307.218 181.948C307.028 181.948 306.841 181.986 306.665 182.058C306.49 182.131 306.331 182.238 306.197 182.372L303.546 185.023L308.978 190.454L311.629 187.804Z",
    fill: "white",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 119.343,
    y: 82.3684,
    width: 16.6259,
    height: 16.6259,
    rx: 3,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 238.549,
    y: 87.9561,
    width: 11.9694,
    height: 6.38165,
    rx: 3,
    fill: "#E2E2E6",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 248.793,
    y: 85.1624,
    width: 11.9694,
    height: 11.9694,
    rx: 5.98471,
    fill: "#16BA9B",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 86.0248,
    width: 82.8852,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 93.4752,
    width: 26.0762,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 119.343,
    y: 113.101,
    width: 16.6259,
    height: 16.6259,
    rx: 3,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 238.549,
    y: 118.689,
    width: 11.9694,
    height: 6.38165,
    rx: 3,
    fill: "#E2E2E6",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 248.793,
    y: 115.895,
    width: 11.9694,
    height: 11.9694,
    rx: 5.98471,
    fill: "#16BA9B",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 116.758,
    width: 73.5723,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 124.208,
    width: 26.0762,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 119.343,
    y: 143.834,
    width: 16.6259,
    height: 16.6259,
    rx: 3,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 238.549,
    y: 149.422,
    width: 11.9694,
    height: 6.38165,
    rx: 3,
    fill: "#E2E2E6",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 248.793,
    y: 146.628,
    width: 11.9694,
    height: 11.9694,
    rx: 5.98471,
    fill: "#16BA9B",
    stroke: "#493F58",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 147.49,
    width: 81.9539,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 144.419,
    y: 154.941,
    width: 26.0762,
    height: 1.86259,
    rx: 0.931295,
    fill: "#FFC244",
    stroke: "#493F58",
    strokeWidth: 1.86259,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageIco);
export default __webpack_public_path__ + "static/media/loginPageIco.d3b7f061b3ce6cd55cdc17142996c007.svg";
export { ForwardRef as ReactComponent };